import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49839ca1")

_pushScopeId("data-v-49839ca1")
const _hoisted_1 = { class: "flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-bold margin-right-10" }, "模式: ", -1)
const _hoisted_3 = { class: "el-button-group" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("浅色")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("深色")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-bold margin-left-20 margin-right-10" }, "发布状态: ", -1)
const _hoisted_8 = { class: "el-button-group" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("已发布")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("未发布")
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("选图")
const _hoisted_14 = { class: "list" }
const _hoisted_15 = { class: "visual-area" }
const _hoisted_16 = { class: "publish-area" }
const _hoisted_17 = {
  key: 0,
  class: "published txt"
}
const _hoisted_18 = {
  key: 1,
  class: "unpublished txt"
}
const _hoisted_19 = { class: "publish-button" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消发布")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("删除")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_image_uploader = _resolveComponent("image-uploader")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_image_picker = _resolveComponent("image-picker")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: _ctx.visualModeSelected(undefined) ? 'primary' : '',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterImages({published: _ctx.publishedFilter})))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          type: _ctx.visualModeSelected('LIGHT') ? 'primary' : '',
          icon: "el-icon-sunny",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterImages({visualMode: 'LIGHT', published: _ctx.publishedFilter})))
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          type: _ctx.visualModeSelected('DARK') ? 'primary' : '',
          icon: "el-icon-moon",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterImages({visualMode: 'DARK', published: _ctx.publishedFilter})))
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: _ctx.publishedFilterSelected(undefined) ? 'primary' : '',
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterImages({visualMode: _ctx.visualModeFilter})))
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          type: _ctx.publishedFilterSelected(true) ? 'primary' : '',
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterImages({visualMode: _ctx.visualModeFilter, published: true})))
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          type: _ctx.publishedFilterSelected(false) ? 'primary' : '',
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterImages({visualMode: _ctx.visualModeFilter, published: false})))
        }, {
          default: _withId(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      _hoisted_12,
      _createVNode(_component_image_uploader, { onSuccess: _ctx.handleImageUploaded }, null, 8, ["onSuccess"]),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible=true))
      }, {
        default: _withId(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _createVNode("ul", _hoisted_14, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backgroundImages, (image) => {
        return (_openBlock(), _createBlock("li", {
          key: image.pexelsPhotoId,
          class: "list-item"
        }, [
          _createVNode(_component_el_image, {
            src: image.smallImageSrc
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_el_switch, {
              modelValue: image.visualMode,
              "onUpdate:modelValue": ($event: any) => (image.visualMode = $event),
              onChange: ($event: any) => (_ctx.updateImage(image)),
              "active-color": "black",
              "inactive-color": "lavender",
              "active-value": "DARK",
              "inactive-value": "LIGHT",
              "active-text": "深色",
              "inactive-text": "浅色"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _createVNode("div", _hoisted_16, [
            (image.published)
              ? (_openBlock(), _createBlock("div", _hoisted_17, "已发布"))
              : (_openBlock(), _createBlock("div", _hoisted_18, "未发布"))
          ]),
          _createVNode("div", _hoisted_19, [
            (image.published)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "mini",
                  type: "info",
                  onClick: ($event: any) => (_ctx.unPublishImage(image))
                }, {
                  default: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "mini",
                  type: "success",
                  onClick: ($event: any) => (_ctx.publishImage(image))
                }, {
                  default: _withId(() => [
                    _hoisted_21
                  ]),
                  _: 2
                }, 1032, ["onClick"])),
            _createVNode(_component_el_popconfirm, {
              onConfirm: ($event: any) => (_ctx.deleteImage(image)),
              title: "确定删除吗？"
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_button, {
                  size: "mini",
                  type: "danger"
                }, {
                  default: _withId(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_dialog, {
      title: "选图",
      top: "10px",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: "80%"
    }, {
      default: _withId(() => [
        _createVNode(_component_image_picker, { onSelected: _ctx.handleSelected }, null, 8, ["onSelected"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})